import React from 'react';
import ActionButton from '@applied/dragonfruit/src/components/ActionButton/ActionButton';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import Modal from '@applied/dragonfruit/src/components/Modal/Modal';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import '../../basic-modal-styles.scss';

type NumbersReceivedModalProps = {
  onClose: () => void;
};

export function NumbersReceivedModal(props: NumbersReceivedModalProps): JSX.Element {
  const { onClose } = props;

  return (
    <Modal className="numbers-received-modal" onClose={onClose}>
      <Flex direction="column" alignment="center" justify="center" gap="md">
        <Flex className="text-container" direction="column" gap="sm">
          <Typography variant="subtitle">Numbers received</Typography>
          <Typography variant="caption">
            Please reach out to your recruiter if you have any questions!
          </Typography>
        </Flex>
        <ActionButton
          className="numbers-received-modal-button"
          appearance="primary"
          onClick={onClose}
        >
          <Typography variant="body">OK</Typography>
        </ActionButton>
      </Flex>
    </Modal>
  );
}
